// extracted by mini-css-extract-plugin
module.exports = {"productTileContainer":"relatedProduct-module__productTileContainer___3VFiX","buyButtonRowContainer":"relatedProduct-module__buyButtonRowContainer___1866o"};